module.exports = __webpack_public_path__ + "img/36-dec.66355228.png";